import { createReducer, on } from '@ngrx/store';
import { SpecCheckState } from 'app/state/models/organizations/specs.model';
import * as SpecActions from '../../actions/organizations/specs.actions';
import * as ProjectsActions from '../../actions/organizations/projects.actions';
import * as AuthActions from '../../actions/auth.actions';

export const initialSpecsState: SpecCheckState = {
  specCheckResults: []
};

export const specsReducer = createReducer(
  initialSpecsState,
  on(SpecActions.checkSpecAndCreateVersionSuccess, (state, { uploadIntentId, results }) => {
    const existingIndex = state.specCheckResults.findIndex(r => r.uploadIntentId === uploadIntentId);
    if (existingIndex >= 0) {
      const updated = [...state.specCheckResults];
      updated[existingIndex] = { uploadIntentId, results };
      return {
        ...state,
        specCheckResults: updated
      };
    }
    return {
      ...state,
      specCheckResults: [...state.specCheckResults, { uploadIntentId, results }]
    };
  }),
  on(SpecActions.getSpecValidationResultsSuccess, (state, { uploadIntentId, results }) => {
    const existingIndex = state.specCheckResults.findIndex(r => r.uploadIntentId === uploadIntentId);
    if (existingIndex >= 0) {
      const updated = [...state.specCheckResults];
      updated[existingIndex] = { uploadIntentId, results };
      return {
        ...state,
        specCheckResults: updated
      };
    }
    return {
      ...state,
      specCheckResults: [...state.specCheckResults, { uploadIntentId, results }]
    };
  }),
  on(AuthActions.logout, AuthActions.clearUserData, () => initialSpecsState)
);
